import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "src/App";
import DataNotFound from "src/components/pages/DataNotFound";

const RouteComp = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="*" element={<DataNotFound />} /> 
      </Routes>
    </Router>
  );
};

export default RouteComp;
